import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { sessionCacheSaga } from './saga';
import { SessionCacheState } from './types';

export const initialState: SessionCacheState = {
  loading: true,
};

const slice = createSlice({
  name: 'sessionCache',
  initialState,
  reducers: {
    initialized(state) {
      state.loading = false;
    },
  },
});

export const { actions: sessionCacheActions } = slice;

export const useSessionCacheSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: sessionCacheSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSessionCacheSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
